/**
 * Where the app can be installed. One list for the download section, the footer and the
 * structured data, so a new store listing is added in one place.
 *
 * Android only: the iOS app (Sibapp/Anardoni listings) was retired on 2026-11-03. iPhone visitors
 * are sent to the web app instead (`download_iphone` in webApp.js).
 */
export const ANDROID_STORES = [
    { id: 'bazaar', name: 'کافه‌بازار', url: 'https://cafebazaar.ir/app/ir.hooshpaz.hooshpaz' },
    { id: 'myket', name: 'مایکت', url: 'https://myket.ir/app/ir.hooshpaz.hooshpaz' },
];

export const STORE_URLS = ANDROID_STORES.map((store) => store.url);
